import { api } from './api';

interface ExportResponse {
  fileName: string;
  mimeType: string;
  content: string; // base64 encoded
  recordCount: number;
  exportedAt: string;
}

export const exportData = async (
  format: 'csv' | 'excel',
  fields: string[],
  filters: Record<string, any>
): Promise<ExportResponse> => {
  try {
    const response = await api.post('/export', {
      format,
      fields,
      filters,
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to export data:', error);
    throw error;
  }
};

export const downloadFile = (content: string, fileName: string, mimeType: string) => {
  const byteCharacters = atob(content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
